import { render, staticRenderFns } from "./AllJournals.vue?vue&type=template&id=9724221a&"
import script from "./AllJournals.vue?vue&type=script&lang=js&"
export * from "./AllJournals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports